function ContactStatic() {

  return (
    <div></div>
  );
}

export default ContactStatic;